<template>
    <div>
        <kgr-loading v-if="loading" />
        <kgr-empty-data
            v-if="empty && !loading"
            :value="$t('Keine Daten vorhanden')"
        />
        <div
            v-if="!empty"
            class="chart"
        >
            <highcharts
                :options="chartOptions"
                :highcharts="Highcharts"
            />
        </div>
        <div>
            <kgr-button
                v-if="!loading"
                :disabled="jobRunning"
                @click="createUpdateJob"
            >
                {{ $t('Aktualisieren') }}
            </kgr-button>
            <span v-if="jobRunning">{{ $t('Die Daten werden im Hintergrund berechnet. Die Grafik aktualisiert sich sobald die Daten verfügbar sind.') }}</span>
        </div>
    </div>
</template>

<script>
import ClubStatsRepository from '../../js/repository/ClubStatsRepository';
import EmptyData from '../common/EmptyData';
import Highcharts from 'highcharts';
import KgrButton from '../common/form/button/KgrButton';
import Loading from '../common/Loading';
import More from 'highcharts/highcharts-more';

More(Highcharts);

export default {
    name: 'KgrMemberDemographics',
    components: {
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
        'kgr-button': KgrButton,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        departmentId: {
            type: Number,
            required: false,
            default: null,
        },
        teamId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            empty: true,
            loading: true,
            jobRunning: false,
            Highcharts,
            chartOptions: {
                chart: {
                    type: 'packedbubble',
                },
                title: {
                    text: this.$t('club.stats.member.demographics.title'),
                },
                tooltip: {
                    useHTML: true,
                    pointFormat: `<span class="kgr-text--bold">${this.$t('member.age')} {point.tooltip}:</span> {point.value}`,
                },
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    packedbubble: {
                        maxSize: '80%',
                        layoutAlgorithm: {
                            gravitationalConstant: 0.05,
                            splitSeries: true,
                            seriesInteraction: true,
                            dragBetweenSeries: false,
                            parentNodeLimit: true,
                        },
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}',
                            style: {
                                color: 'black',
                                textOutline: 'none',
                                fontWeight: 'var(--kgr-font-weight-normal)',
                            },
                        },
                    },
                },
                series: [],
                legend: {
                    itemStyle: {
                        fontWeight: 'var(--kgr-font-weight-bold)',
                    },
                },
            },
        };
    },
    mounted() {
        this.loadMembershipDemographics();
    },
    methods: {
        loadMembershipDemographics() {
            ClubStatsRepository.getMembershipDemographics(this.clubId, this.departmentId, this.teamId)
                .then((stats) => {
                    this.empty = stats.length === 0;
                    this.loading = false;
                    this.chartOptions.series = stats;
                });
        },
        loadRunningJob() {
            ClubStatsRepository.getMembershipDemographicsJob(this.clubId, this.departmentId, this.teamId)
                .then((response) => {
                    this.jobRunning = response.isRunning;
                    if (this.jobRunning === false) {
                        this.loadMembershipDemographics();
                    }
                })
                .finally(() => {
                    if (this.jobRunning === true) {
                        setTimeout(() => {
                            this.loadRunningJob();
                        }, 1000);
                    }
                });
        },
        createUpdateJob() {
            ClubStatsRepository.putMembershipDemographicsJob(this.clubId, this.departmentId, this.teamId)
                .then(() => {
                    this.jobRunning = true;
                    this.loadRunningJob();
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.chart {
    margin: 0 auto;
}
</style>
